// authService.js
export function getCurrentUser() {
  return  localStorage.getItem('userEmail'); // Certifique-se que isto retorna o e-mail correto;
}
